import { useTranslation } from "react-i18next";
import style from "./LongestStreak.module.css";
import { padZero } from "@/utils/helpers";

import Icon from "@/ui/icon/Icon";

function LongestStreak({ activity }) {
	const { t } = useTranslation();
	const longestStreakCount = calculateLongestStreak(activity);

	function calculateLongestStreak(activityDates) {
		if (!activityDates || activityDates.length === 0) {
			return 0;
		}

		// Sort dates in chronological order (oldest to newest)
		const sortedDates = [...activityDates].sort(
			(a, b) => new Date(a) - new Date(b)
		);

		let longestStreak = 0;
		let currentStreak = 1;

		// Compare adjacent dates for consecutive days
		for (let i = 1; i < sortedDates.length; i++) {
			const currentDate = new Date(sortedDates[i]);
			const prevDate = new Date(sortedDates[i - 1]);

			// Calculate the difference in days
			const diffTime = currentDate - prevDate;
			const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

			if (diffDays === 1) {
				// Consecutive day - increase streak
				currentStreak++;
			} else if (diffDays > 1) {
				// Gap detected - reset streak
				longestStreak = Math.max(longestStreak, currentStreak);
				currentStreak = 1;
			}
		}

		// Update longest streak if the last streak was the longest
		longestStreak = Math.max(longestStreak, currentStreak);

		return longestStreak;
	}

	return (
		<div className={style.holder}>
			<span className={style.label}>
				<Icon icon="fa-trophy" />
				<span>{t("courses:streak.longest")}</span>
			</span>
			<span className={style.value}>{padZero(longestStreakCount)}</span>
		</div>
	);
}

export default LongestStreak;
